import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'status-gather',
  templateUrl: './status-gather.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryStatusGatherComponent implements OnInit {
  @Input() data;
  @Output() moveNextPreviousEvent = new EventEmitter<any>();

  innerContent = {
    subTitle: 'If you have finished collecting the recommended items, mark this as complete and move to the next step.',
  };

  ngOnInit(): void {
    this.innerContent[
      'title'
    ] = `Mark  <span class="font-bold text-[#25508E]"> Gather </span> for  <span class="font-bold text-[#25508E]"> ${this.data?.path_name} </span> complete?`;
  }

  previousNextStatusEvent(event) {
    this.moveNextPreviousEvent.emit({ status: event?.status, ...(event.status == 'forward' && { id: this.data?.id }) });
  }
}
